/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import { ListItem, ListItemText } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import SkipNextIcon from '@material-ui/icons/SkipNext';




const styles = {
  list: {
    width: 250
  },
  fullList: {
    width: "auto"
  }
};

class Instances extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;


    return (
      <Drawer
        anchor="right"
        open={this.props.show}
        onClose={this.props.closeDrawer}
      >
        <div className={classes.list}>
          <List>
            {this.props.instances &&
            this.props.instances.map(item => {
              var itemNumero = parseInt(item.toString().split(" ")[1]);
              console.log(itemNumero)
              return (
                  <Fragment key={item}>
                    <ListItem>
                      <ListItemText primary={item} />
                      <IconButton onClick={()=> {
                        if (this.props.matrixType === "TrainMatrix") {
                          this.props.volverInicio()
                          this.props.changeTab(itemNumero)
                        } else if(this.props.matrixType === "TestMatrix"){
                          this.props.volverInicio()
                          this.props.changeTabTest(itemNumero)
                        }
                      }} edge="end" aria-label="delete">
                        <SkipNextIcon />
                      </IconButton>
                    </ListItem>
                    <Divider />
                  </Fragment>
              );
            })}
          </List>
        </div>
      </Drawer>
    );
  }
}

Instances.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Instances);
